import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { CredibilityTier } from '../types/contact'

interface AuthState {
  token: string | null
  username: string | null
  role: string | null
  credibilityTier: CredibilityTier | null
  setAuth: (token: string, username: string, role: string, credibilityTier: CredibilityTier) => void
  clearAuth: () => void
  isAdmin: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      username: null,
      role: null,
      credibilityTier: null,
      setAuth: (token, username, role, credibilityTier) =>
        set({ token, username, role, credibilityTier }),
      clearAuth: () => set({ token: null, username: null, role: null, credibilityTier: null }),
      isAdmin: () => get().role === 'admin',
    }),
    { name: 'bio-auth' },
  ),
)
